<button [ngStyle]="buttonStyle" class="select-button" [matMenuTriggerFor]="menu">
  <span class="text">{{ buttonText }}</span>
  <mat-icon svgIcon="chevron-down"></mat-icon>
</button>
<mat-menu #menu="matMenu" class="oph-select-menu">
  @for (option of options; track $index) {
    <button class="oph-select-menu-item" (click)="optionClick.emit(option.value)">{{ option.name }}</button>
  }
</mat-menu>
